<!-- AchievementCard.vue -->
<template>
  <div class="card">
    <div class="content">
      <p class="description">{{ title }}</p>

      <div class="progress-bar">
        <div
            class="progress-fill"
            :style="{ width: percent + '%' }"
        ></div>
        <span class="progress-label">{{ current }} / {{ total }}</span>
      </div>

      <p class="description">{{ description }}</p>
    </div>

    <div class="icon" v-if="!isAchieved">
      <img src="../../images/icons/isNotAch.svg" />
    </div>
    <div class="icon" v-if="isAchieved">
      <img src="../../images/icons/isAch.svg" />
    </div>

  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
const props = defineProps({
  title: {
    type: String,
    default: 'Всем привяка'
  },
  current: {
    type: Number,
    default: 10
  },
  total: {
    type: Number,
    default: 200
  },
  description: {
    type: String,
    default: 'Что-то сломалось и это просто текст'
  },
  isAchieved: {
    type: Boolean,
    default: false
  }
})
console.log()
const percent = computed(() => {
  return props.total > 0
      ? Math.min(100, Math.max(0, (props.current / props.total) * 100))
      : 0
})
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: 2px solid #fff;
  border-radius: 20px;
  background: rgba(35, 59, 87, 0.43);
  width: 100%;
  box-sizing: border-box;

  .content {
    flex: 1;
    margin-right: 12px;

    .title {
      margin: 0;
      font-size: 18px;
      color: #fff;
    }

    .progress-bar {
      border: 1px solid #fff;
      position: relative;
      width: 100%;
      height: 24px;
      border-radius: 12px;
      overflow: hidden;
      margin: 15px 0;

      .progress-fill {
        position: absolute;
        top: -1px;
        border-radius: 12px;
        border: 1px solid #fff;
        height: 100%;
        background: linear-gradient(90deg, #2598EA, #155684);
        transition: width 0.3s ease;
      }

      .progress-label {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        line-height: 24px;
        text-align: center;
        font-size: 14px;
        color: #fff;
        pointer-events: none;
      }
    }

    .description {
      margin: 0;
      font-size: 13px;
      color: #fff;
    }
  }

  .icon {
    img {
      width: 61px;
      height: 61px;
    }
  }
}
</style>
